import * as React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { colorOptions } from '../utils/constants';

interface PieChartDataItem {
  eventTagId: number;
  count: number;
  tagName: string;
  tagColour: string;
}

const EventTagPieChart = ({
  pieChartData,
}: {
  pieChartData: PieChartDataItem[];
}) => {
  const getColour = (color: string) => {
    const colorOption = colorOptions.find((option) => option.value === color);
    return colorOption ? colorOption.chipColor : '#9e9e9e'; // Default color if not found
  };

  const pieData = pieChartData.map((item) => {
    return {
      id: item.eventTagId,
      value: item.count,
      label: item.tagName,
      color: getColour(item.tagColour),
    };
  });

  return (
    <PieChart
      series={[
        {
          data: pieData,
          innerRadius: 0,
          outerRadius: 100,
          paddingAngle: 3,
          cornerRadius: 4,
          arcLabel: (item) => `${item.value}`,
          arcLabelMinAngle: 10,
        },
      ]}
      width={600}
      height={350}
      slotProps={{
        legend: {
          position: { vertical: 'middle', horizontal: 'right' },
          direction: 'column',
          itemMarkWidth: 16,
          itemMarkHeight: 16,
          markGap: 8,
          itemGap: 8,
          padding: 0,
        },
      }}
    />
  );
};

export default EventTagPieChart;
